import { en } from './en';
import { vi } from './vi';
import { fr } from './fr';
export * from './translateCodes';

export const defaultLocale = {
    en,
    vi,
    fr
};